import type { ComponentType } from 'react';

import { M1Activity } from '@/app/(platform)/(subscription-gated)/labs/_engine/screens/m1-activity';
import { M1Intro } from '@/app/(platform)/(subscription-gated)/labs/_engine/screens/m1-intro';
import { M1Results } from '@/app/(platform)/(subscription-gated)/labs/_engine/screens/m1-results';
import { M2Activity } from '@/app/(platform)/(subscription-gated)/labs/_engine/screens/m2-activity';
import { M2Intro } from '@/app/(platform)/(subscription-gated)/labs/_engine/screens/m2-intro';
import { M3Activity } from '@/app/(platform)/(subscription-gated)/labs/_engine/screens/m3-activity';
import { M3Reading } from '@/app/(platform)/(subscription-gated)/labs/_engine/screens/m3-reading';

import { PreviewPayoff } from '../_partials/preview-payoff';
import { PreviewWelcome } from '../_partials/preview-welcome';
import type { PreviewStep } from './preview-steps';

/**
 * Step → component for the PUBLIC PREVIEW.
 *
 * Eight of the ten entries are the sprint's own screens, imported unchanged. That is the whole point
 * of the engine's design: screens take no props and read everything from `usePack()` / `useLabsStore()`,
 * so they render identically on a surface they were never written for. A fix to M1 lands on both.
 *
 * TWO substitutions, at the two ends, and both are about what the surface PROMISES and DELIVERS:
 *
 *   - `welcome`, the sprint's front door promises 15 minutes and an analysis of a real company. The
 *     preview is five minutes and analyses nothing. Reusing it would open by advertising the product
 *     this is a cut of. See `preview-welcome.tsx`.
 *   - `recommendations`, the sprint's exit sends a paying learner into a program; the preview has to
 *     convert an anonymous reader into a signup. Same step id (so progress, funnels and abandon points
 *     stay comparable), different screen.
 *
 * `Record<PreviewStep, …>` is exhaustive over the preview's sequence at compile time, exactly as the
 * sprint's registry is over all 18, so a step added to `PREVIEW_STEPS` cannot be left unrendered.
 */
export const PREVIEW_SCREENS: Record<PreviewStep, ComponentType> = {
  welcome: PreviewWelcome,
  'm1-intro': M1Intro,
  'm1-activity': M1Activity,
  'm1-results': M1Results,
  'm2-intro': M2Intro,
  'm2-activity': M2Activity,
  'm3-reading': M3Reading,
  'm3-activity': M3Activity,
  recommendations: PreviewPayoff,
};
